export default __webpack_public_path__ + "static/media/exit.13e9c472.svg";